// extracted by mini-css-extract-plugin
module.exports = {"coverLevels":"coverLevels_coverLevels__hAMfb","coverHeading":"coverLevels_coverHeading__1WtUn","copy":"coverLevels_copy__qeG31","tables":"coverLevels_tables__CLEQr"};